<template>
  <div class="tags-container">
    <ScrollPane
      ref="scrollPane"
      class="tags-view-wrapper"
      @scroll="handleScroll"
    >
      <router-link
        ref="tag"
        tag="span"
        class="tags-view-item"
        v-for="tag in visitedViews"
        :class="tag.fullPath === $route.fullPath ? 'active' : ''"
        :key="tag.fullPath"
        :to="tag.fullPath"
        @click.middle.native="
          tag.path !== '/dashborad' ? closeSelectTag(tag) : ''
        "
        @contextmenu.prevent.native="openMenu(tag, $event)"
      >
        {{ tag.title }}
        <i
          v-if="tag.path !== '/dashborad'"
          class="el-icon-close"
          @click.prevent.stop="closeSelectTag(tag)"
        />
      </router-link>
    </ScrollPane>
    <ul v-show="visible" :style="{ left: left + 'px', top: top + 'px' }">
      <li @click="refreshSelectTag(selectTag)">刷新</li>
      <li
        @click="closeSelectTag(selectTag)"
        v-if="selectTag.path !== '/dashborad'"
      >
        关闭
      </li>
      <li @click="closeOtherTags">关闭其他</li>
      <li @click="closeAllTags(selectTag)">关闭所有</li>
    </ul>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ScrollPane from "./ScrollPane";
export default {
  components: {
    ScrollPane,
  },
  computed: {
    ...mapState("layout", ["visitedViews"]),
  },
  data() {
    return {
      visible: false,
      left: 0,
      top: 0,
      selectTag: {},
    };
  },
  watch: {
    $route() {
      this.addTags();
      this.moveToCurrentTag();
    },
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
  },
  mounted() {
    this.iniTag();
    this.addTags();
  },
  methods: {
    handleScroll() {
      this.closeMenu();
    },
    iniTag() {
      if (this.$route.path === "/dashborad") {
        this.$store.dispatch("layout/addVisitedView", this.$route);
      }
    },
    addTags() {
      const { name } = this.$route;
      if (name) {
        this.$store.dispatch("layout/addView", this.$route);
      }

      return false;
    },

    closeSelectTag(view) {
      this.$store.dispatch("layout/delView", view).then(({ visitedViews }) => {
        if (view.path === this.$route.path) {
          this.toLastView(visitedViews, view);
        }
      });
    },
    toLastView(visitedView, view) {
      const latestView = visitedView.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        this.$router.push("/dashborad");
      }
    },
    openMenu(tag, e) {
      const menuWidth = 100;
      const offsetWidth = this.$el.offsetWidth;
      const offsetLeft = this.$el.getBoundingClientRect().left;

      const maxLeft = offsetWidth - menuWidth;
      const left = e.clientX - offsetLeft + 15;

      if (left > maxLeft) {
        this.left = maxLeft;
      } else {
        this.left = left;
      }

      this.top = e.clientY;
      this.visible = true;
      this.selectTag = tag;
    },
    closeMenu() {
      this.visible = false;
    },
    refreshSelectTag(tag) {
      this.$store.dispatch("layout/delCachedView", tag).then((res) => {
        this.$nextTick(() => {
          this.$router.replace({ path: "/redirect" + tag.fullPath });
        });
      });
    },
    closeOtherTags() {
      this.$router.push(this.selectTag);
      this.$store.dispatch("layout/delOthersViews", this.selectTag).then(() => {
        this.moveToCurrentTag();
      });
    },
    closeAllTags(tag) {
      this.$store.dispatch("layout/delAllViews").then(({ visitedViews }) => {
        if (tag.path === "/dashborad") return;

        this.toLastView(visitedViews, tag);
      });
    },

    moveToCurrentTag() {
      const tags = this.$refs.tag;
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag);
          }
          break;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.tags-container {
  width: 100%;
  height: 34px;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
  .tags-view-wrapper {
    .tags-view-item {
      box-sizing: border-box;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 26px;
      border: 1px solid #d8dce5;
      color: #495060;
      font-size: 12px;
      padding: 0 8px;
      margin-top: 4px;
      margin-left: 5px;
      cursor: pointer;
      &:first-of-type {
        margin-left: 15px;
      }
      &:last-of-type {
        margin-right: 15px;
      }
      &.active {
        background-color: #42b983;
        color: #fff;
        border-color: #42b983;
      }
      i {
        text-align: center;
        width: 16px;
        height: 16px;
        line-height: 16px;
        margin-left: 3px;
        border-radius: 50%;
        transition: all 0.28s cubic-bezier(0.645, 0.045, 0.355, 1);
        &::before {
          display: inline-block;
          transform: scale(0.6);
          margin-top: 1px;
        }
        &:hover {
          background-color: #b4bcccf2;
          &::before {
            color: #fff;
            cursor: pointer;
          }
        }
      }
    }
  }
  ul {
    position: absolute;
    z-index: 1000;
    padding: 5px 0;
    border-radius: 4px;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    background-color: #fff;
    font-size: 10px;
    font-weight: 400;
    list-style-type: none;
    li {
      width: 80px;
      height: 27px;
      padding: 7px 16px;
      cursor: pointer;
      margin: 0;
      &:hover {
        background-color: #eee;
      }
    }
  }
}
</style>